import { apiClient, PaginatedApiResponse } from "../lib/apiClient";
import {
  Template,
  CreateTemplateRequest,
  UpdateTemplateRequest,
} from "../types/models/template";

export class TemplateService {
  static async getTemplates(
    page: number = 1,
    pageSize: number = 10,
    search?: string,
  ): Promise<PaginatedApiResponse<Template[]>> {
    const params: Record<string, string> = {
      page: page.toString(),
      page_size: pageSize.toString(),
    };

    if (search) {
      params.search = search;
    }

    return apiClient.getPaginated<Template>(
      "/api/v1/admin/:storeId/web-builder/templates",
      params,
    );
  }

  static async createTemplate(data: CreateTemplateRequest): Promise<Template> {
    const response = await apiClient.post<Template>(
      "/api/v1/admin/:storeId/web-builder/templates",
      data,
    );
    return response.data;
  }

  static async updateTemplate(
    templateId: string,
    data: UpdateTemplateRequest,
  ): Promise<Template> {
    const response = await apiClient.put<Template>(
      `/api/v1/admin/:storeId/web-builder/templates/${templateId}`,
      data,
    );
    return response.data;
  }

  static async deleteTemplate(templateId: string): Promise<void> {
    await apiClient.delete(
      `/api/v1/admin/:storeId/web-builder/templates/${templateId}`,
    );
  }

  static async getTemplateById(templateId: string): Promise<Template> {
    // apiClient.get already unwraps the response (it returns ApiResponse<T>
    // where `data` is the actual payload). Return `response.data` which is
    // the Template object.
    const response = await apiClient.get<Template>(
      `/api/v1/admin/:storeId/web-builder/templates/${templateId}`,
    );
    return response.data;
  }

  static async getTemplateBySlug(templateSlug: string): Promise<Template> {
    const response = await apiClient.get<Template>(
      `/api/v1/admin/:storeId/web-builder/templates/slug/${templateSlug}`,
    );
    return response.data;
  }
}
